// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBillingVoucherSearchResponse

import { hydrateBillingVoucher, type BillingVoucher, type BillingVoucherApiResponse } from './billingVoucher.gen';

export type AdminBillingVoucherSearchApiResponse = {
	items: BillingVoucherApiResponse[];
};

export type AdminBillingVoucherSearch = {
	items: BillingVoucher[];
};

export function hydrateAdminBillingVoucherSearch(data: AdminBillingVoucherSearchApiResponse): AdminBillingVoucherSearch {
	return {
		...data,
		items: data.items.map(hydrateBillingVoucher),
	};
}